import React from "react";
import chevronsSmall from "../../assets/images/chevrons-small.png";
import timeFunction from "../../functions/getTime";

export default function NewsCard(props) {
  return (
    <div
      onClick={() => {
        if (props.page === "newsAndActivity/news")
          window.open(
            `/${props.lang}/${props.page}/${props.data.slug}`,
            "_self"
          );
        else if (props.page === "article")
          window.open(
            `/${props.lang}/${props.page}/${props.data.slug}`,
            "_self"
          );
      }}
      className="group cursor-pointer w-full h-[260px] rounded-[12px] items-start flex flex-col justify-end p-[20px] !bg-cover"
      style={
        props.data.image && props.data.image[0]
          ? {
              background: `linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 80%), url(${process.env.REACT_APP_API_URL}${props.data.image[0].url}) center / cover no-repeat`,
            }
          : { background: `#D9D9D9` }
      }
    >
      <p
        onClick={() => {
          if (props.page === "newsAndActivity/news")
            window.open(
              `/${props.lang}/${props.page}/${props.data.slug}`,
              "_self"
            );
          else if (props.page === "article")
            window.open(
              `/${props.lang}/${props.page}/${props.data.slug}`,
              "_self"
            );
        }}
        className={
          `capitalize cursor-pointer text-lead leading-tight text-white font-medium text-left ` +
          (props.lineClamp ? `line-clamp-${props.lineClamp}` : "line-clamp-1")
        }
      >
        {props.lang === "th"
          ? props.data.title.detail_TH
          : props.data.title.detail_EN}
      </p>
      <div className="flex justify-between items-center mt-[9px] w-full">
        <h1 className="text-meta text-white font-medium text-left">
          {timeFunction.getTime(props.data.publishedAt, props.lang)}
        </h1>
        {!props.hideIcon && (
          <img className="w-[18px] cursor-pointer" src={chevronsSmall} alt="" />
        )}
      </div>
    </div>
  );
}
